/**
 * アンカーリンク関連 Class
 */
export default class Anchor {
  constructor () {
    this.scrollEvent();
    this.pageTop();
    this.pageTopVisible();
  }

  /**
   * スクロールイベント
   */
  scrollEvent() {
    window.addEventListener('scroll', this.pageTopVisible);
  };

  /**
   * ページトップ
   */
  pageTop() {
    $(document).on('click', '#js-pagetop', function () {
      $('html, body').scrollTop(0);
      return false;
    });
  };

  /**
   * ページトップアイコン表示切り替え
   */
  pageTopVisible() {
    let $scrollVal = $(window).scrollTop();
    if (0 < $scrollVal) {
      $('#js-pagetop').addClass('is-active');
    } else {
      $('#js-pagetop').removeClass('is-active');
    }
  };
}
